import React from "react";

const Coalerinfo = () => {
  return (
    <>
      <div
        id="how-it-works"
        className="min-h-[832px] bg-transparent bg-no-repeat bg-center bg-cover text-white flex justify-center pt-[110px] "
        style={{
          backgroundImage: `
    linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 50%, #000000 100%),
    url('/coalersecond.png')`,
        }}
      >
        <div className="flex flex-col items-center justify-between ">
          <div className="text-center flex flex-col gap-6 items-center max-w-[787px]">
            <h1
              className="text-4xl font-extrabold leading-10 bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, #AB93FA 0%, #4410EE 100%)",
              }}
            >
              {/* <h1 className="font-extrabold text-4xl leading-10 background-image:linear-gradient(180deg, #B8A5F7 0%, #6138E4 100%)"> */}
              What is Coaler?
            </h1>
            <div>
              <p className="text-4xl font-extrabold leading-10">
                One Platform, Endless Possibilities:
              </p>
              <p className="text-4xl font-extrabold leading-10">
                Your{" "}
                <span
                  className=" bg-clip-text text-transparent"
                  style={{
                    backgroundImage:
                      "linear-gradient(90deg, #AB93FA 0%, #4410EE 100%)",
                  }}
                >
                  Coal Ecosystem
                </span>{" "}
                Starts Here
              </p>
            </div>
          </div>

          <div className="max-w-[870px] ">
            <ul className="flex flex-col gap-6 font-medium laeding-[160%] ">
              {[
                {
                  listItem:
                    "Coaler is India’s first unified digital marketplace for the coal industry, connecting vendors, transporters, and buyers nationwide.",
                },
                {
                  listItem:
                    "Built on blockchain and smart contracts, it ensures secure, transparent transactions while automating payments and documentation.",
                },
                {
                  listItem:
                    " From coal-rich states to industrial hubs, Coaler streamlines trade, cuts inefficiencies, and drives growth in India’s $50B+ coal market. Plus, earn COALER Coin with every transaction and redeem rewards like discounts or priority support.",
                },
              ].map((item, i) => (
                <li key={i} className="flex gap-6">
                  <img src="/Cone_updated.png" alt="" className="w-12 h-12" />
                  {item.listItem}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Coalerinfo;
